import firebase from 'firebase/app'
import 'firebase/functions'

const functions = firebase.app().functions('asia-northeast1')

// TODO:: remove this line when build
functions.useFunctionsEmulator('http://localhost:5001')

export default functions
